import ListingActivationConstants from '../constants/ListingActivationConstants';

const listingActivationUtils = {
  isFailedActivationErrorCode(code: string) {
    return Object.values(ListingActivationConstants.ERROR_CODE).includes(code);
  },
};

export default listingActivationUtils;
